
(function () {
    'use strict';
    var DAO = function (opts) {
        var self = this;
        var config = cylindo.getModule('cylindo.core.config');
        var network = cylindo.getModule('cylindo.core.network');
        var utils = cylindo.getModule('cylindo.core.util');
        var pubsub = cylindo.getModule('cylindo.util.pubsub').create();
        var database = cylindo.getModule('cylindo.classes.database').create({
            logger: opts.logger,
            viewerData: opts.viewerData
        });
        var logger = opts.logger;
        var currentDataStatus = opts.currentDataStatus;
        var settings = {
            defaults: config.get('defaults'),
            urls: config.get('urls'),
            metadata: config.get('metadata')
        };
        var requestsAborted = [];
        var previousRequestID = 0;
        var isFirstRun = true;

        this.utils = utils;
        this.fetchFeatures = fetchFeatures;
        this.updatePaths = updatePaths;
        this.getResolvedFeatures = getResolvedFeatures;
        this.destroy = destroy;
        this.on = pubsub.on;
        this.off = pubsub.off;
        this.trigger = pubsub.trigger;

        function fetchFeatures(params) {
            var deferred = utils.promise.create();
            var address;
            var ftToBeShown = params.features instanceof Array ? params.features.slice() : [];
            var featuresKey = ftToBeShown.join('*');
            var _productData = (params && params.currentFeatures && params.currentFeatures.data) ? params.currentFeatures.data : null;
            var paramsCopy = utils.object.extend({}, params, { additionalData: _productData && _productData.loaded ? false : true, ftToBeShown: ftToBeShown });
            var picturePaths = utils.picture.getPaths(settings, paramsCopy);
            var productCode = params.productCode;
            var dbKey = params.useConfigurationAlias ? params.configurationAlias : ftToBeShown.join('*');
            var variation = database && database.isInitialized() ?
                database.getData(productCode + '-' + dbKey) : null;
            var refRequestID;
            var startFrame = params.startFrame || 1;
            var styleshots = [];
            var firstFeaturesFailed = false;
            var firstSetOfFeatures = [];
            var requestID = null;
            address = picturePaths.framePath.replace('__FRAME_INDEX__', startFrame);
            if (ftToBeShown instanceof Array) {
                if (previousRequestID) {
                    requestsAborted.push(previousRequestID);
                    network.abort(previousRequestID);
                }
                if (variation) {
                    tryToResolve(variation);
                }
                else {
                    previousRequestID = requestID = network.doRequest(
                        address,
                        function (response, xhr) {
                            var productData;
                            var urlMaker = window.URL || window.webkitURL;
                            isFirstRun = false;
                            productData = _productData && _productData.loaded ? _productData : xhr && xhr.getResponseHeader ? JSON.parse(xhr.getResponseHeader('Additional-Content')) : null;
                            productData = utils.object.extend({}, productData);
                            productData.loaded = true;
                            if (!productData) {
                                reject(params);
                                return;
                            }
                            productData.imageUrl = urlMaker.createObjectURL(response);
                            productData.startFrame = startFrame;
                            previousRequestID = null;
                            if (response) {
                                if (response.vid !== 0) {
                                    self.ViewerID = response.vid;
                                }
                                if (database) {
                                    if(!database.isInitialized()) {
                                        database.init();
                                    }
                                    database.processData(productCode, featuresKey, productData);
                                    tryToResolve(productData);
                                }
                                else {
                                    logger.error('Database module not found.');
                                    reject(params);
                                }
                            }
                            else {
                                reject(params);
                            }
                        },
                        {
                            method: 'OPTIONS'
                        },
                        function (errorResponse, xhr) {
                            var abortedIndex = requestsAborted.indexOf(requestID);
                            var fr;
                            var retryDeferred;
                            var errMsgs = {
                                FIRST_RUN: 'First set of features failed while trying to get the images. Trying with the default set of features instead.',
                                DEFAULT: 'Set of features or configuration alias failed while trying to get the images.',
                                CONFIG_ALIAS_DEFAULT: 'Configuration alias failed while trying to get the images.',
                                ABORTED: 'Set of features canceled'
                            };
                            if (abortedIndex !== -1) {
                                requestsAborted.splice(abortedIndex, 1);
                                logger.error(errMsgs.ABORTED, ftToBeShown);
                                return;
                            }
                            if (isFirstRun && !params.useConfigurationAlias) {
                                firstFeaturesFailed = true;
                                firstSetOfFeatures = params.features;
                                isFirstRun = false;
                                logger.error(errMsgs.FIRST_RUN, params.features);
                                params.features = [];
                                retryDeferred = fetchFeatures(params);
                                retryDeferred.then(resolve, reject);
                            }
                            else {
                                try {
                                    fr = new FileReader();
                                    fr.onload = function () {
                                        reject({
                                            error: this.result
                                        });
                                        if (params.useConfigurationAlias) {
                                            logger.error(errMsgs.CONFIG_ALIAS_DEFAULT, this.result, ftToBeShown);
                                        }
                                        else {
                                            logger.error(errMsgs.DEFAULT, this.result, ftToBeShown);
                                        }
                                    };
                                    fr.readAsText(errorResponse.response);
                                }
                                catch (ex) {
                                    reject(errorResponse);
                                    if (params.useConfigurationAlias) {
                                        logger.error(errMsgs.CONFIG_ALIAS_DEFAULT, errorResponse, ftToBeShown);
                                    }
                                    else {
                                        logger.error(errMsgs.DEFAULT, errorResponse, ftToBeShown);
                                    }
                                }
                            }
                        },
                        'blob'
                    );
                }
            }
            else {
                reject(params);
            }
            function reject(params) {
                deferred.reject(params);
            }
            function resolve(params) {
                if (params) {
                    params.firstFeaturesFailed = firstFeaturesFailed;
                    params.firstSetOfFeatures = firstSetOfFeatures;
                    deferred.resolve(params);
                }
                else {
                    reject(params);
                }
            }
            function tryToResolve(productData) {
                if (productData && productData.error) {
                    reject(productData);
                }
                else {
                    ++currentDataStatus.requestID;
                    refRequestID = currentDataStatus.requestID;
                    picturePaths = updatePaths(paramsCopy);
                    styleshots = productData.styleshots;
                    logger.log('Set of features resolved succesfully.', productData);
                    resolve({
                        paths: picturePaths,
                        data: productData,
                        refRequestID: refRequestID,
                        ftToBeShown: ftToBeShown,
                        styleshots: styleshots,
                    });
                }
            }

            return deferred;
        }

        function updatePaths(params) {
            delete params.additionalData;
            return utils.picture.getPaths(settings, params);
        }

        function getResolvedFeatures(params, cb) {
            var requestOpts = {
                type: 'GET'
            };
            var picturePaths = utils.picture.getPaths(settings, params);
            network.doRequest(
                picturePaths.resolvedFtPath,
                function (response, xhr) {
                    if (cb) {
                        cb(response);
                    }
                },
                requestOpts,
                function (response, xhr) {
                    if (cb) {
                        cb(response);
                    }
                },
                null
            );
        }    

        function destroy() {
            if (previousRequestID) {
                network.abort(previousRequestID);
            }
            database = null;
            self.trigger(self.events.DESTROYED);
        }
    };

    DAO.prototype.events = {
        DESTROYED: 'dao:destroyed',
    };

    var publicAPI = {
        create: function (opts) {
            return new DAO(opts);
        }
    };

    window.cylindo.addModule('DAO', publicAPI);
}).call(this);